import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHouzzComponent } from './simple-icons-houzz.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHouzzComponent ],
    exports:      [ SimpleIconsHouzzComponent ],
    bootstrap:    []
})
export class SimpleIconsHouzzModule {}
